import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ManageLightspeed from './ManageLightspeed'
import { PARTNER_SLUGS } from '../constants'

export const ManageIntegrations = () => {
  return (
    <Switch>
      <Route
        path={`/integrations/${PARTNER_SLUGS.LIGHTSPEED}`}
        exact
        component={ManageLightspeed}
      />
    </Switch>
  )
}

export default ManageIntegrations
